import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface DashboardStats {
  totalUsers: number;
  meetingsToday: number;
  activeSubscriptions: number;
}

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard-stats'],
    queryFn: () => apiClient<DashboardStats>('/dashboard/stats'),
  });
}
